import { useState } from "react";
import { FIRST_PAGE_VALUE, FormActionType, PER_PAGE_VALUE } from "../config/global";

export default function useHeaderFunctionPage({ baseApiUrl, title }: { baseApiUrl: string, title: string }) {
    const [pagination, setPagination] = useState({ page: FIRST_PAGE_VALUE, perPage: PER_PAGE_VALUE });
    const [openModal, setOpenModal] = useState(false);
    const [currentElement, setCurrentElement] = useState<any>(0);
    const [titleForm, setTitleForm] = useState("");
    const [actionForm, setActionForm] = useState<FormActionType>(FormActionType.ADD);
    const [status, setStatus] = useState<undefined|string>(undefined);
    const queryKey = [`${baseApiUrl}s`, pagination.page, pagination.perPage,status];
    const [downloadLoading, setDownloadLoading] = useState(false);

    return {
        pagination, setPagination,
        openModal, setOpenModal,
        currentElement, setCurrentElement,
        titleForm, setTitleForm,
        actionForm, setActionForm,
        status, setStatus,
        downloadLoading, setDownloadLoading,
        baseApiUrl,
        title,
        queryKey
    };
}

